import { createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import firebase from "../../firebase/config";
import { IUser, InewsLetter, RootState } from "../type";
import axios from 'axios';
import { arrayUnion, doc, getDoc, updateDoc } from "firebase/firestore";
import admin from 'firebase-admin';


//action
//sending data to firebase
export const sendMessage = createAsyncThunk("sendMessage", async (data : any, {rejectWithValue}) =>{
//for local testing
    // try {
    //   const db = firebase.firestore();
    //   await db.collection("messages").doc("newsletter").update(
    //     {
    //       description: data.description,
    //       updatedAt: data.updatedAt,
    //       createdAt: data.createdAt,
    //       title: data.title,
    //       file: data.file,
    //       eventDate: data.eventDate
    //     }
    //   );
    //   return data;
    // } 
    // catch (error) {
    //   return rejectWithValue(error);
    // }

// for server
      try {
      const db = firebase.firestore();
      await db.collection("Game_Config").doc("GameData").update(
        {
          News_Description: data.description,
          News_Heading: data.title,
          News_Image_URL: data.file,
          News_Date: data.eventDate
        }
      );
      return data;
    } 
    catch (error) {
      return rejectWithValue(error);
    }


})

export const sendPrivacyPolicy = createAsyncThunk("sendPrivacyPolicy", async (data : any, {rejectWithValue}) =>{
  // for server
  console.log("send privacy api")
        try {
        const db = firebase.firestore();
        await db.collection("Game_Config").doc("PrivacyPolicy").set(
          {
            Description: data.description,
            updatedAt : data.updatedAt
          },  { merge: true }
        );
        return data;
      } 
      catch (error) {
        return rejectWithValue(error);
      }
  
  
  })

export const sendBanner = createAsyncThunk("sendBanner", async (data : any, {rejectWithValue}) =>{
//for local testing
console.log("send banner data is", data)

  // try {
  //   const db = firebase.firestore();
  //   await db.collection("messages").doc("banner").update(
  //     {  
  //       Image1: data[0],
  //       Image2: data[1] || "",
  //       Image3: data[2] || "",
  //       Image4: data[3] || "",
  //       Image5: data[4] || "",
  //     }
  //   );
  //   return data;
  // } 
  // catch (error) {
  //   return rejectWithValue(error);
  // }

//for server
    try {
      const db = firebase.firestore();
      await db.collection("Game_Config").doc("AdvertisementData").update(
        {  
          Image1: data[0],
          Image2: data[1] || "",
          Image3: data[2] || "",
          Image4: data[3] || "",
          Image5: data[4] || "",
          Image6: data[5] || "",
          Image7: data[6] || "",
          Image8: data[7] || "",
        }
      );
      return data;
    } 
    catch (error) {
      return rejectWithValue(error);
    }


})

export const sendWinnerAnnouncementNotification = createAsyncThunk("sendWinnerAnnouncementNotification", async (data : any, {rejectWithValue}) =>{
  // for server
  console.log("data in sendWinnerAnnouncementNotification",data)
        try {
        const db = firebase.firestore();
        
        const convertDateFormat = (dateString : any) => {
          const [year, month, day] = dateString.split("-").map(Number); // Convert strings to numbers
          const monthNames = [
            "Jan", "Feb", "March", "April", "May", "June",
            "July", "Aug", "Sept", "Oct", "Nov", "Dec"
          ];
          const monthName = monthNames[month - 1]; // Month is 1-indexed
          return `${day} ${monthName} ${year}`; // Returns format like '16 October 2024'
        };
        const formattedDate = convertDateFormat(data.announcementDate);

        await db.collection("prize").doc("prizeData").update(
          {
            descriptionForPushNotification: data.descriptionForPushNotification.replace(/\n/g, "_n"),
            descriptionForEmail: data.descriptionForEmail.replace(/\n/g, "_n"),
            title: data.title,
            pushNotificationAndEmailDate: data.pushNotificationAndEmailDate,
            pushNotificationAndEmailTime: data.pushNotificationAndEmailTime,
            announcementDate : formattedDate,
            sendPushNotification : data.sendPushNotification,
            sendEmail : data.sendEmail,
            isAddedInInGameNotification : data.isAddedInInGameNotification,
            scoreReset: true,
            notificationUID : data.notificationUID
          }
        );

        return data;
      } 
      catch (error) {
        return rejectWithValue(error);
      }
  })

  export const sendManualPushNotification = createAsyncThunk("sendManualPushNotification", async (data : any, {rejectWithValue}) =>{
    // for server
    console.log("data in sendManualPushNotification",data)
          try {
          const db = firebase.firestore();
          if(data.sendPushNotificationNow){
            console.log("inside if of sendManualPushNotification")
            const url = 'https://us-central1-fernandesdriverman-cd237.cloudfunctions.net/onSendManualPushNotification'

            const response = await axios.post(url, data,{
                headers: {
                    'Content-Type': 'application/json'
                }
            });
          }else{
            const scheduledManualPushNotificationRef = db.collection("scheduledManualPushNotification");

          await scheduledManualPushNotificationRef.add(
            {
              descriptionForPushNotification: data.descriptionForPushNotification.replace(/\n/g, "_n"),
              title: data.title,
              pushNotificationAndEmailDate: data.pushNotificationAndEmailDate,
              pushNotificationAndEmailTime: data.pushNotificationAndEmailTime,
              notificationUID: data.notificationUID
            }
          );
        }
          return data;
        } 
        catch (error) {
          return rejectWithValue(error);
        }
    })
// action
// fetching data from firebase
export const showAllUsers = createAsyncThunk("showUser", async (data, { rejectWithValue }) => {
  try {
      const db = firebase.firestore();
      const response = await db.collection('users').get();
      const users =  response.docs.map((doc) => ({id: doc.id, ...doc.data()}));
    return users;
  } 
  catch (error) {
    return rejectWithValue(error);
  }
}
)

//client rejected the idea of blocking/unblocking user
// export const blockUserInDatabase = createAsyncThunk ("userBlock",async (user: any,{ rejectWithValue } ) => {
//   try {
//     const db = firebase.firestore();
//     await db.collection('users').doc(user.id).update({
//       Active_Status: true,
//     });
//     const doc = await db.collection("users").doc(user.id).get();
//     return {id: doc.id, ...doc.data()}
//   } catch (error) {
//     throw error; 
//   }
// })

// export const unblockUserInDatabase = createAsyncThunk ("userUnblock",async (user: any,{ rejectWithValue } ) => {
//   try {
//     const db = firebase.firestore();
//     await db.collection('users').doc(user.id).update({
//       Active_Status: false,
//     });
//     const doc = await db.collection("users").doc(user.id).get();
//     return {id: doc.id, ...doc.data()}

//   } catch (error) {
//     throw error; 
//   }
// })


export const deleteUserInDatabase = createAsyncThunk ("deleteUser",async (userId: any,{ rejectWithValue } ) => {
  try {
    console.log("user id to be deleted", userId)
    const url = "https://us-central1-fernandesdriverman-cd237.cloudfunctions.net/onDeleteUserFromAuth"
    const response = await axios.post(url, {userId:userId} );
    console.log("after hitting deleteUserInDatabase api",response.data.message);
    return userId

  } catch (error) {
    throw error; 
  }
})

export const sendEmailToUser = createAsyncThunk ("sendEmailToUser" ,async (emailData: any,{ rejectWithValue } ) => {
  const url = "https://us-central1-fernandesdriverman-cd237.cloudfunctions.net/onSendEmail"

  console.log('hitting api sendEmailToUser ', emailData);
  try {

    const response = await axios.post(url, emailData );
    console.log("after hitting send email to user api",response.data.message);
  } catch (error) {
    console.log('Error in sending email');
    throw error; 
  }
})

export const sendOtpForChangePassword = createAsyncThunk ("sendOtpForChangePassword" ,async () => {
  const url = "https://us-central1-fernandesdriverman-cd237.cloudfunctions.net/sendOtpForChangePasswordAdmin"

  console.log('hitting api sendOtpForChangePassword');
  try {

    const response = await axios.post(url);
    console.log("after hitting sendOtpForChangePassword api",response.data.message);
  } catch (error) {
    console.log('Error in sending mail sendOtpForChangePassword');
    throw error; 
  }
})

export const confirmChangePassword = createAsyncThunk ("confirmChangePassword" ,async (data : any, { rejectWithValue } ) => {
  console.log('hitting confirmChangePassword api');
  try {
    const db = firebase.firestore();
    const adminCredentialsSnapshot = await db.collection('admin').doc('adminCredentials').get();
    const adminData = adminCredentialsSnapshot.data();
      
    const { otp, newPassword } = data;
    const otpInInt = Number(otp)
    // Check if the OTP matches
    if (adminData?.otp === otpInInt) {
      await db.collection("admin").doc("adminCredentials").update({
        password: newPassword,
        otp: null, 
      });
      return { message: 'Password updated successfully.', };
    }
    return rejectWithValue('Invalid OTP');

  } catch (error) {
    console.log('Error occurred');
    throw error; 
  }
})

export const sendOtpForForgotPassword = createAsyncThunk ("sendOtpForForgotPassword" ,async () => {
  const url = "https://us-central1-fernandesdriverman-cd237.cloudfunctions.net/sendOtpForForgotPasswordAdmin"

  console.log('hitting sendOtpForForgotPassword api');
  try {

    const response = await axios.post(url);
    console.log("after hitting sendOtpForForgotPassword api response",response.data.message);
  } catch (error) {
    console.log('Error in sending mail sendOtpForForgotPassword');
    throw error; 
  }
})

export const confirmForgotPasswordAndSave = createAsyncThunk ("confirmForgotPasswordAndSave" ,async (data : any, { rejectWithValue } ) => {
  console.log('hitting api confirmForgotPasswordAndSave');
  try {
    const db = firebase.firestore();
    const adminCredentialsSnapshot = await db.collection('admin').doc('adminCredentials').get();
    const adminData = adminCredentialsSnapshot.data();
      
    const { otpForForgotPassword, newPassword } = data;
    const  otpForForgotPasswordInInt = Number(otpForForgotPassword)
    // Check if the OTP matches
    if (adminData?.otpForForgotPassword === otpForForgotPasswordInInt) {
      await db.collection("admin").doc("adminCredentials").update({
        password: newPassword,
        otpForForgotPassword: null, 
      });
      return { message: 'Password updated successfully.', };

    }
    return rejectWithValue('Invalid OTP');

  } catch (error) {
    console.log('Error occurred');
    throw error; 
  }
})

const initialState ={
    users : [],
    messages : [],
    loading: false,
    success: false,
    error : null,
    time: '',
    currentPage: 1,
    usersPerPage: 7,

}

export const sendMessageSlice = createSlice({
    name: "messageHandler",
    initialState,
    reducers : { 
      onNavigateNext : (state : any) =>{
        state.currentPage++;
      },
      onNavigatePrev : (state : any) =>{
        state.currentPage--;
      },
      onClickCurrentPage : (state : any, action: PayloadAction<number>)=>{
        state.currentPage = action.payload
      },
      onClickMessageTypeFilter: (state : any, action: PayloadAction<string>) => {
        state.selectedMessageType = action.payload;
        state.currentPage = 1;
      },
    },
    extraReducers: (builder)=>{
        builder
        .addCase(sendMessage.pending, (state : any) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(sendMessage.fulfilled, (state :any, action: PayloadAction<any>) => {
            state.loading = false;
            console.log("action.payload", action.payload)
            // state.messages.push(action.payload);
            const updatedNewsletter = action.payload;
            console.log("updated message calling==========")
            state.messages.map((newsLetter : InewsLetter)=>{
              if(newsLetter.id== updatedNewsletter.id){
                newsLetter.description = updatedNewsletter.description;
                newsLetter.title = updatedNewsletter.title;
                newsLetter.createdAt = updatedNewsletter.createdAt;
                newsLetter.file = updatedNewsletter.file;
                newsLetter.eventDate = updatedNewsletter.eventDate
              }
            }
            )
            state.success = true;

        })
        .addCase(sendMessage.rejected, (state : any, action : PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(showAllUsers.pending, (state : any) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(showAllUsers.fulfilled, (state :any, action: PayloadAction<any>) => {
            state.loading = false;
            state.users = action.payload;

        })
        .addCase(showAllUsers.rejected, (state : any, action : PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload;
            state.users = [];

        })
        // .addCase(blockUserInDatabase.pending, (state: any) => {
        //     state.loading = false;
        //     state.error = null;
        //     state.updatedUserId = null;
        //   })
        // .addCase(blockUserInDatabase.fulfilled, (state : any, action : PayloadAction<any>) => {
        //     state.loading = false;
        //     state.error = null;
        //     const updatedUser = action.payload;
        //     console.log("block user calling==========")
        //     console.log("updated user in block=",action)
        //     state.users.map((user : IUser)=>{
        //       if(user.Id== updatedUser.Id){
        //         console.log("inside if of blockindb")
        //         user.Active_Status = updatedUser.Active_Status;
        //       }
        //     })
        //   })
        // .addCase(blockUserInDatabase.rejected, (state : any, action : PayloadAction<any>) => {
        //     state.loading = false;
        //     state.error = action.payload || "Failed to block user.";
        //     state.updatedUserId = null;
        //   })
        //   .addCase(unblockUserInDatabase.pending, (state: any) => {
        //     state.loading = false;
        //     state.error = null;
        //     state.updatedUserId = null;
        //   })
        // .addCase(unblockUserInDatabase.fulfilled, (state : any, action : PayloadAction<any>) => {
        //     state.loading = false;
        //     state.error = null;
        //     const updatedUser = action.payload;
        //     console.log("unblock user calling==========")
        //     state.users.map((user : IUser)=>{
        //       if(user.Id== updatedUser.Id){
        //         user.Active_Status = updatedUser.Active_Status;
        //       }
        //     })
        //   })
        // .addCase(unblockUserInDatabase.rejected, (state : any, action : PayloadAction<any>) => {
        //     state.loading = false;
        //     state.error = action.payload || "Failed to unblock user.";
        //     state.updatedUserId = null;
        //   })
          .addCase(deleteUserInDatabase.pending, (state: any) => {
            state.loading = false;
            state.error = null;
            state.updatedUserId = null;
          })
        .addCase(deleteUserInDatabase.fulfilled, (state : any, action : PayloadAction<any>) => {
            state.loading = false;
            state.error = null;
            console.log("delete user calling==========")
            state.users = state.users.filter((user: IUser) => user.Id !== action.payload);

          })
        .addCase(deleteUserInDatabase.rejected, (state : any, action : PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload || "Failed to delete user.";
            state.updatedUserId = null;
          })
          .addCase(sendEmailToUser.pending, (state) => {
            state.loading = true;
            console.log("sendEmailToUser calling pending==========")

          })
          .addCase(sendEmailToUser.fulfilled, (state, action) => {
            state.loading = false;
            console.log("sendEmailToUser calling fulfil==========")

          })
          .addCase(sendEmailToUser.rejected, (state, action) => {
            state.loading = false;
            console.log(" sendEmailToUser calling rejcted==========")

          })
          .addCase(sendManualPushNotification.pending, (state) => {
            state.loading = true;
            console.log("sendManualPushNotification calling pending==========")

          })
          .addCase(sendManualPushNotification.fulfilled, (state, action) => {
            state.loading = false;
            console.log("sendManualPushNotification calling fulfil==========")

          })
          .addCase(sendManualPushNotification.rejected, (state, action) => {
            state.loading = false;
            console.log(" sendManualPushNotification calling rejcted==========")

          })
          .addCase(sendBanner.pending, (state : any) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(sendBanner.fulfilled, (state :any, action: PayloadAction<any>) => {
            state.loading = false;
            console.log("action.payload", action.payload)
            state.data = action.payload;
            state.success = true;

        })
        .addCase(sendBanner.rejected, (state : any, action : PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(sendWinnerAnnouncementNotification.pending, (state : any) => {
          state.loading = true;
          state.error = null;
      })
      .addCase(sendWinnerAnnouncementNotification.fulfilled, (state :any, action: PayloadAction<any>) => {
          state.loading = false;
          console.log("action.payload", action.payload)
          state.data = action.payload;
          state.success = true;

      })
      .addCase(sendWinnerAnnouncementNotification.rejected, (state : any, action : PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload;
      })
      .addCase(sendPrivacyPolicy.pending, (state : any) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(sendPrivacyPolicy.fulfilled, (state :any, action: PayloadAction<any>) => {
        state.loading = false;
        console.log("action.payload", action.payload)
        state.data = action.payload;
        state.success = true;

    })
    .addCase(sendPrivacyPolicy.rejected, (state : any, action : PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
    })          
    .addCase(sendOtpForChangePassword.pending, (state : any) => {
      state.loading = true;
      console.log("sendOtpForChangePassword calling pending==========")

    })
    .addCase(sendOtpForChangePassword.fulfilled, (state : any, action : PayloadAction<any>) => {
      state.loading = false;
      console.log("sendOtpForChangePassword calling fulfil==========")

    })
    .addCase(sendOtpForChangePassword.rejected, (state : any, action : PayloadAction<any>) => {
      state.loading = false;
      console.log(" sendOtpForChangePassword calling rejcted==========")

    })
    .addCase(confirmChangePassword.pending, (state : any) => {
      state.loading = true;
      console.log("confirmChangePassword calling pending==========")

    })
    .addCase(confirmChangePassword.fulfilled, (state :any, action: PayloadAction<any>) => {
      state.loading = false;
      console.log("confirmChangePassword calling fulfil==========")
  
    })
    .addCase(confirmChangePassword.rejected, (state:any, action: PayloadAction<any>) => {
      state.loading = false;
      console.log(" confirmChangePassword calling rejcted==========")

    })
    .addCase(confirmForgotPasswordAndSave.pending, (state : any) => {
      state.loading = true;
      console.log("confirmForgotPasswordAndSave calling pending==========")

    })
    .addCase(confirmForgotPasswordAndSave.fulfilled, (state :any, action: PayloadAction<any>) => {
      state.loading = false;
      console.log("confirmForgotPasswordAndSave calling fulfil==========")
  
    })
    .addCase(confirmForgotPasswordAndSave.rejected, (state:any, action: PayloadAction<any>) => {
      state.loading = false;
      console.log(" confirmForgotPasswordAndSave calling rejcted==========")

    });

    }

})

export const SendMessageAction = sendMessageSlice.actions
export const sendMessageReduce = sendMessageSlice.reducer;

